(function () {
  function initBrandPopup(root, media) {
    var trigger = root.querySelector('[data-sms-brand-open]');
    var dialog = root.querySelector('[data-sms-brand-dialog]');
    var home = root.querySelector('[data-sms-brand-home]');
    var content = root.querySelector('[data-sms-brand-content]');
    var body = dialog && dialog.querySelector('[data-sms-brand-dialog-body]');
    var close = dialog && dialog.querySelector('[data-sms-brand-close]');
    if (!trigger || !home || !content || !body || !close || typeof dialog.showModal !== 'function') return;

    root.appendChild(dialog);

    function releaseDialog() {
      if (dialog.open) return;
      document.documentElement.classList.remove('sms-brand-popup-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (media.matches && root.isConnected) trigger.focus({ preventScroll: true });
    }

    function applyBrandLayout() {
      if (!media.matches && dialog.open) dialog.close();
      (media.matches ? body : home).appendChild(content);
      root.setAttribute('data-sms-brand-popup-ready', '');
    }

    trigger.addEventListener('click', function () {
      if (!media.matches || dialog.open) return;
      dialog.showModal();
      document.documentElement.classList.add('sms-brand-popup-open');
      trigger.setAttribute('aria-expanded', 'true');
      close.focus({ preventScroll: true });
    });
    close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('close', releaseDialog);
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(root) && dialog.open) dialog.close();
    });
    media.addEventListener('change', applyBrandLayout);
    applyBrandLayout();
  }

  function init(root) {
    if (root.hasAttribute('data-sms-mobile-product-ready')) return;
    root.setAttribute('data-sms-mobile-product-ready', '');
    var media = window.matchMedia('(max-width: 749px)');
    initBrandPopup(root, media);
    var disclosures = Array.from(root.querySelectorAll('[data-sms-mobile-disclosure]'));
    var summary = root.querySelector('.sms-visual-summary');

    function wrapRoomFits() {
      if (!summary) return;
      summary.querySelectorAll('.sms-visual-best').forEach(function (best) {
        if (best.closest('[data-sms-mobile-disclosure="room-fit"]')) return;
        var label = root.getAttribute('data-sms-mobile-room-label');
        if (!label) return;
        var disclosure = document.createElement('details');
        disclosure.className = 'sms-mobile-room-fit';
        disclosure.setAttribute('data-sms-mobile-disclosure', 'room-fit');
        disclosure.setAttribute('data-sms-mobile-disclosure-ready', '');
        disclosure.open = !media.matches;
        var toggle = document.createElement('summary');
        toggle.className = 'sms-mobile-product-disclosure__summary';
        var text = document.createElement('span');
        text.textContent = label;
        var icon = document.createElement('b');
        icon.textContent = '+';
        icon.setAttribute('aria-hidden', 'true');
        toggle.append(text, icon);
        disclosure.appendChild(toggle);
        best.before(disclosure);
        disclosure.appendChild(best);
        disclosures.push(disclosure);
      });
    }

    function openHashTarget() {
      var hash = window.location.hash.slice(1);
      if (!hash) return;
      try { hash = decodeURIComponent(hash); } catch (error) { return; }
      var target = document.getElementById(hash);
      if (!target || !root.contains(target)) return;
      var disclosure = target.closest('[data-sms-mobile-disclosure]');
      if (disclosure) disclosure.open = true;
    }

    function applyLayout() {
      disclosures.forEach(function (disclosure) {
        disclosure.open = !media.matches;
        disclosure.setAttribute('data-sms-mobile-disclosure-ready', '');
      });
      openHashTarget();
    }

    wrapRoomFits();
    applyLayout();
    if (summary) new MutationObserver(wrapRoomFits).observe(summary, { childList: true, subtree: true });
    media.addEventListener('change', applyLayout);
    window.addEventListener('hashchange', openHashTarget);
  }

  function boot(scope) {
    scope.querySelectorAll('[data-sms-visual-pdp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
